import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit
} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {
  StripePaymentSelectionService,
  getState,
  selectIsLoggedIn$
} from '@spout/global-web/data-access';
import {
  BehaviorSubject,
  Observable,
  Subject,
  distinctUntilChanged,
  takeUntil
} from 'rxjs';
import {ServiceLocator} from '../service-locator/service-locator';
import {Store, select} from '@ngrx/store';
import {AccountState, ENVIRONMENT, IEnvironmentState} from '@spout/global-web/models';

@Component({
  selector: 'spt-new-checkout',
  templateUrl: './new-checkout.component.html',
  styleUrls: ['./new-checkout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewCheckoutComponent implements OnInit {
  public isPerMonth$: BehaviorSubject<boolean>;
  public isPerMonth: boolean = false;
  public tier$: BehaviorSubject<number>;
  public tier: number = -1;
  public loggedIn$: BehaviorSubject<boolean>;
  public loaded$: BehaviorSubject<boolean>;
  public hasPromo$: BehaviorSubject<boolean>;
  public hasPromo: boolean = false;
  public EARLYADOPTER: number = 0;
  public PROMO: number = 1;
  public PERSONAL: number = 2;
  public BAND: number = 3;
  public storage: number = 0;
  public COLLABORATOR: number = 4;
  private loaded: boolean = false;
  private triggeredPromo: boolean = false;
  constructor(
    private activatedRoute: ActivatedRoute,
    private ServiceLocator: ServiceLocator,
    private store: Store,
    private router: Router,
    private cd: ChangeDetectorRef,
    public payment: StripePaymentSelectionService,
    @Inject(ENVIRONMENT) public environment: IEnvironmentState) {
    this.tier$ = new BehaviorSubject(1);
    this.tier$.subscribe((x: any) => {
      this.tier = parseInt(x);
    });
    this.hasPromo$ = new BehaviorSubject(false);
    this.hasPromo$ = new BehaviorSubject(false);
    this.hasPromo$.subscribe(x => {
      this.hasPromo = x;
    });
    this.loggedIn$ = new BehaviorSubject(false);
    this.loaded$ = new BehaviorSubject(false);
    this.loaded$.subscribe(x => {
      this.loaded = x;
    });
    this.isPerMonth$ = new BehaviorSubject(false);
    this.isPerMonth$.subscribe((x: any) => {
      this.isPerMonth = x == true;
    });
  }

  ngOnInit(): void {
    this.store
      .pipe(select(getState), distinctUntilChanged())
      .subscribe((account: AccountState | null) => {
        if (account) {
          var StepParam = this.activatedRoute.snapshot.queryParams['s'];
          if (StepParam != undefined && StepParam != null && StepParam != '') {
            console.log('NewCheckoutComponent | ' + StepParam);
            this.tier$.next(parseInt(StepParam));
            this.tier = parseInt(StepParam);
            this.hasPromo$.next(StepParam == 1);
            if (account.isRetrievedFromFirestore == true) {
              if (this.loaded === true) return;
              this.payment.init(() => {
                console.log('this.payment.init');
                this.loaded$.next(true);
                this.isPerMonth$.next(true);
                let tierString = this.GetTierString();
                this.payment.updatePrice(tierString);
                this.payment.updateStorageQty(0);
                this.cd.detectChanges();
                console.log(tierString);
                console.log(this.payment);
              });
            }
          }

          this.loggedIn$.next(account.isLoggedIn == true);
          this.cd.detectChanges();
        }
      });

    var OpenPromo =
      this.activatedRoute.snapshot.queryParams['openPromo'] == 'true';
    if (this.triggeredPromo == false && OpenPromo == true) {
      this.triggeredPromo = true;
      console.log('Open Promo');
      setTimeout(() => {
          let personal_monthly = this.environment?.production == false?'price_1IZmBNFr7h7OltJtiT03hVUf':'price_1L7zVXFr7h7OltJt6dwDoVEr';
        this.payment.updatePrice(personal_monthly);
        this.payment.updateStorageQty(0);
        this.payment.onCheckout(true);
      }, 1000);
    }
  }
  Login() {
    //open login page
    this.router.navigate(['signup-with-promo']);
  }
  UpdateCart(isPerMonth: boolean) {
    if (this.loaded == false) return;
    this.isPerMonth$.next(isPerMonth);
    let tierString = this.GetTierString();

    this.payment.updatePrice(tierString);
  }
  UpdateStorage(event: any) {
    console.log('UpdateStorage' + event);
    this.storage = parseInt(event);
    this.payment.updateStorageQty(event);
  }
  OnCheckOut() {
    console.log('OnCheckOut');
    if (this.loaded == false) return;
    let tierString = this.GetTierString();
    console.log('OnCheckOut |' + tierString);

    this.payment.updatePrice(tierString);
    this.payment.updateStorageQty(0);

    this.payment.onCheckout(this.tier == this.PROMO);
    //  this.router.navigate(["/downloads"])
  }
  GetTotal() {
    var base = 0;
    if (this.tier == this.PERSONAL && this.isPerMonth == true) {
      base += this.storage * 3;
      base += 10;
    } else if (this.tier == this.PERSONAL && this.isPerMonth == false) {
      base += this.storage * 3 * 12;
      base += 72;
    } else {
    }
    return base;
  }
  GetTierString() {
    let personal_monthly = this.environment?.production == false?'price_1IZmBNFr7h7OltJtiT03hVUf':'price_1L7zVXFr7h7OltJt6dwDoVEr';
    let personal_yearly = this.environment?.production == false?'price_1OZJXTFr7h7OltJtsTXRsXS1':'price_1Obp6cFr7h7OltJtux3raUCO';
    let collaborator = this.environment?.production == false?'price_1IaHDxFr7h7OltJtib45ynFh':'price_1L7zTkFr7h7OltJtzbHBjHV7';
    let tierString = personal_monthly;
    if (this.tier == this.PROMO && this.isPerMonth == true) {
      tierString = personal_monthly;
    } else if (this.tier == this.PROMO && this.isPerMonth == false) {
      tierString = personal_monthly;
    } else if (this.tier == this.PERSONAL && this.isPerMonth == true) {
      tierString = personal_monthly;
    } else if (this.tier == this.PERSONAL && this.isPerMonth == false) {
      tierString = personal_yearly;
    } else if (this.tier == this.COLLABORATOR && this.isPerMonth == true) {
      tierString =collaborator;
    } else if (this.tier == this.COLLABORATOR && this.isPerMonth == false) {
      tierString = collaborator;
    }
    console.log(this.tier + ' | ' + tierString);
    return tierString;
  }
}
